<template>
  <div class="has-padding--mobile header-container header-padding">
    <div class="columns is-tablet">
      <div class="column is-10 is-offset-1">
        <div
          class="menu-left"
          @click="$router.push({ name: 'Exchange' })"
        >
          <img
            src="/static/svg/kulap-logo.svg"
            class="kulap-logo"
          >
        </div>
        <div class="menu-right">
          <!-- Desktop -->
          <div class="menu-columns is-hidden-touch">
            <div class="menu-column menu-item cursor-pointer">
              <b-dropdown
                id="header-lang-desktop-button"
                aria-role="list"
                position="is-bottom-left"
                data-test="header--desktop-change-lang-button"
              >
                <div
                  slot="trigger"
                  class="header-lang-menu"
                >
                  <img :src="`/static/svg/icon-${$i18n.locale}.svg`">
                  <span>
                    {{ ($i18n.locale).toUpperCase() }}
                  </span>
                  <img src="/static/svg/expand-more.svg">
                </div>

                <b-dropdown-item
                  v-if="$i18n.locale !== 'th'"
                  data-test="header--desktop-select-lang-th"
                  @click.native="selectLang('th')"
                >
                  <div class="header-lang-menu">
                    <img src="/static/svg/icon-th.svg">
                    <span>TH</span>
                  </div>
                </b-dropdown-item>
                <b-dropdown-item
                  v-if="$i18n.locale !== 'en'"
                  data-test="header--desktop-select-lang-en"
                  @click.native="selectLang('en')"
                >
                  <div class="header-lang-menu">
                    <img src="/static/svg/icon-en.svg">
                    <span>EN</span>
                  </div>
                </b-dropdown-item>
              </b-dropdown>
            </div>
            <div class="menu-column menu-item">
              <div v-if="(!user || Object.keys(user).length === 0) && env !== 'insider'">
                <div
                  class="login-button"
                  data-test="header--desktop-login-button"
                  @click="openLoginModal"
                >
                  <img src="/static/svg/person.svg">
                  <span>
                    {{ $t('buttons.login_register') }}
                  </span>
                </div>
              </div>
              <div
                v-click-outside="hideUserPopup"
                v-else-if="env !== 'insider'"
                class="user-avatar"
                data-test="header--desktop-user-avatar"
                @click="showUserPopup"
              >
                <UserAvatar :img="user.profilePicture"/>
                <div
                  v-show="userPopupOpened"
                  class="user-popup"
                  data-test="header--desktop-user-popup"
                >
                  <UserPopup
                    :user="user"
                    @logout="logout"
                  />
                </div>
              </div>
            </div>
            <div class="menu-column menu-item">
              <Notification/>
            </div>
            <div class="menu-column">
              <router-link to="/terms">
                <span :class="['menu-item', {'menu-active': headerName === 'Terms'}]">
                  Terms
                </span>
              </router-link>
              <div
                v-if="headerName === 'Terms'"
                class="menu-active-line"
              />
            </div>
            <div class="menu-column">
              <router-link to="/about">
                <span :class="['menu-item', {'menu-active': headerName === 'About'}]">
                  About
                </span>
              </router-link>
              <div
                v-if="headerName === 'About'"
                class="menu-active-line"
              />
            </div>
            <div class="menu-column">
              <a
                href="https://buy.kulap.io"
                target="_blank"
                rel="noopener noreferrer"
              >
                <span :class="['menu-item', {'menu-active': headerName === 'Buy'}]">
                  Buy
                </span>
              </a>
              <div
                v-if="headerName === 'Buy'"
                class="menu-active-line"
              />
            </div>
            <div class="menu-column">
              <router-link to="/">
                <span :class="['menu-item', {'menu-active': headerName === 'Exchange'}]">
                  Swap
                </span>
              </router-link>
              <div
                v-if="headerName === 'Exchange'"
                class="menu-active-line"
              />
            </div>
          </div>
          <!-- End Desktop -->
          <!-- Mobile -->
          <div class="menu-columns is-hidden-desktop">
            <div class="menu-column">
              <b-dropdown
                ref="dropdownMenuMobile"
                class="icon-menu"
              >
                <img
                  slot="trigger"
                  src="/static/svg/hamburger.svg"
                  data-test="header--mobile-hamburger-button"
                >
                <b-dropdown-item has-link>
                  <router-link
                    to="/"
                    class="header-menu-mobile-router"
                  >
                    <span class="menu-text-style">
                      Swap
                    </span>
                    <div class="header-menu-mobile-divider"/>
                  </router-link>
                </b-dropdown-item>
                <b-dropdown-item has-link>
                  <a
                    href="https://buy.kulap.io"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <span class="menu-text-style">
                      Buy
                    </span>
                    <div class="header-menu-mobile-divider"/>
                  </a>
                </b-dropdown-item>
                <b-dropdown-item has-link>
                  <router-link
                    to="/about"
                    class="header-menu-mobile-router"
                  >
                    <span class="menu-text-style">
                      About
                    </span>
                    <div class="header-menu-mobile-divider"/>
                  </router-link>
                </b-dropdown-item>
                <b-dropdown-item has-link>
                  <router-link
                    to="/terms"
                    class="header-menu-mobile-router"
                  >
                    <span class="menu-text-style">
                      Terms
                    </span>
                    <div class="header-menu-mobile-divider"/>
                  </router-link>
                </b-dropdown-item>
                <b-dropdown-item
                  custom
                  @click.native="toggledropdownMenuMobile"
                >
                  <div
                    class="header-menu-mobile-lang"
                    data-test="header--mobile-change-lang-button"
                  >
                    <div class="menu-text-style">
                      Language
                    </div>
                    <div class="header-lang-menu">
                      <img :src="`/static/svg/icon-${$i18n.locale}.svg`">
                      <span>
                        {{ ($i18n.locale).toUpperCase() }}
                      </span>
                      <img
                        class="lang-mobile-menu-next-ic"
                        src="/static/svg/expand-more.svg"
                      >
                    </div>
                  </div>
                </b-dropdown-item>
              </b-dropdown>
              <b-dropdown
                ref="dropdownMenuMobileChangeLang"
                aria-role="list"
                class="dp-block"
              >
                <b-dropdown-item
                  class="header-menu-mobile-router t-al-left"
                  custom
                  @click.native="toggledropdownMenuMobile"
                >
                  <img
                    class="lang-mobile-menu-back-ic"
                    src="/static/svg/expand-more.svg"
                  >
                  <span class="menu-text-style">
                    Language
                  </span>
                  <div class="header-menu-mobile-divider"/>
                </b-dropdown-item>
                <b-dropdown-item
                  class="header-menu-mobile-router"
                  @click.native="selectLang('th')"
                >
                  <div
                    class="header-lang-menu"
                    data-test="header--mobile-select-lang-th"
                  >
                    <img src="/static/svg/icon-th.svg">
                    <span class="menu-text-style">
                      TH
                    </span>
                  </div>
                  <div class="header-menu-mobile-divider"/>
                </b-dropdown-item>
                <b-dropdown-item @click.native="selectLang('en')">
                  <div
                    class="header-lang-menu"
                    data-test="header--mobile-select-lang-en"
                  >
                    <img src="/static/svg/icon-en.svg">
                    <span class="menu-text-style">
                      EN
                    </span>
                  </div>
                </b-dropdown-item>
              </b-dropdown>
            </div>
            <div class="menu-column">
              <div v-if="(!user || Object.keys(user).length === 0) && env !== 'insider'">
                <b-icon
                  class="icon-account"
                  icon="account"
                  type="is-gray"
                  @click.native="openLoginModal"
                />
              </div>
              <div
                v-click-outside="hideUserPopupOnMobile"
                v-else-if="env !== 'insider'"
                class="pst-relative"
                @click="showUserPopupOnMobile"
              >
                <UserAvatar
                  :img="user.profilePicture"
                  data-test="header--user-avatar-mobile"
                />
                <div
                  v-show="userPopupOnMobileOpened"
                  class="user-popup-mobile"
                  data-test="header--user-popup-mobile"
                >
                  <UserPopup
                    :user="user"
                    @logout="logout"
                  />
                </div>
              </div>
            </div>
            <div class="menu-column">
              <Notification/>
            </div>
          </div>
          <!-- End Mobile -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { kulapApi } from '@/resources'
import Notification from '@/features/Notification'
import UserAvatar from '@/components/UserAvatar'
import UserPopup from './components/UserPopup'
import CongratsToGetReward from '@/components/CongratsToGetReward'
import LoginModal from '@/features/LoginModal'
import Service from './service.js'
import { calTotalKULToken } from '@/utils/helper'
import { mapState } from 'vuex'
import ClickOutside from 'vue-click-outside'
import cookie from '@/utils/cookie'
import { ENV } from '@/constants'

export default {
  name: 'Header',
  directives: {
    ClickOutside
  },
  components: {
    Notification,
    UserAvatar,
    UserPopup,
    LoginModal
  },
  data () {
    return {
      env: ENV,
      headerName: '',
      service: null,
      userPopupOpened: false,
      userPopupOnMobileOpened: false
    }
  },
  computed: {
    ...mapState({
      user: state => state.user
    }),
    showTotalKULToken () {
      return calTotalKULToken(this.user.rewards)
    }
  },
  async created () {
    this.service = new Service({ store: this.$store, kulapApi })
    this.headerName = this.$route.name
    let userProfile = {}
    if (cookie.get('accessToken') && cookie.get('user')) {
      userProfile = await this.service.updateUserData({ initial: true })
    }
    if (userProfile && Object.keys(userProfile).length) {
      this.congratsAfterLogin()
    }
  },
  methods: {
    toggledropdownMenuMobile () {
      this.$refs.dropdownMenuMobile.toggle()
      this.$refs.dropdownMenuMobileChangeLang.toggle()
    },
    selectLang (lang) {
      this.$i18n.locale = lang
      localStorage.setItem('KULAP.user-lang', lang)
    },
    showUserPopup () {
      this.userPopupOpened = !this.userPopupOpened
    },
    hideUserPopup () {
      this.userPopupOpened = false
    },
    showUserPopupOnMobile () {
      this.userPopupOnMobileOpened = !this.userPopupOnMobileOpened
    },
    hideUserPopupOnMobile () {
      this.userPopupOnMobileOpened = false
    },
    openLoginModal (e) {
      this.$buefy.modal.open({
        parent: this,
        component: LoginModal,
        hasModalCard: true,
        canCancel: ['escape', 'outside', 'x'],
        events: {
          loginSuccess: async () => {
            this.congratsAfterLogin()
          }
        }
      })
    },
    async congratsAfterLogin () {
      // Show Modal For login with Google, Facebook First time and KYC Approved
      if (this.$route.name === 'ConfirmEmail') {
        return // Not run script in Page 'ConfirmEmail'
      }
      const data = this.user
      if (data && data.rewards && data.rewards.length) {
        const filterRewards = data.rewards.filter(e => e.options.isOpenCongratsModal)
        if (filterRewards.length) {
          let subTitle = ''
          if (filterRewards.find(e => e.name === 'Registration')) subTitle = this.$t('messages.thanks_for_registration')
          else if (filterRewards.find(e => e.name === 'KYCApproved')) subTitle = this.$t('messages.thanks_for_submited')
          this.$buefy.modal.open({
            parent: this,
            component: CongratsToGetReward,
            hasModalCard: true,
            props: {
              tokenAmount: calTotalKULToken(filterRewards),
              subTitle
            },
            canCancel: ['escape', 'outside']
          })
          const changeRewardsOption = filterRewards.map(e => ({ ...e, options: { isOpenCongratsModal: false } }))
          await kulapApi.putRewardsOption(changeRewardsOption)
          await this.service.updateUserData()
        }
      }
    },
    logout () {
      this.service.logout()
      setTimeout(() => {
        this.$router.push({ name: 'Exchange' })
      }, 500)
    }
  }
}
</script>

<style lang="scss">
#header-lang-desktop-button {
  .dropdown-menu {
    min-width: 0;
  }
}
</style>

<style lang="scss" scoped>
a:visited, a:hover {
  color: black !important;
}
.menu-item a {
  cursor: pointer;
}

.header-container {
  position: relative;
  z-index: 1;
  background-color: #fff;
  height: 110px;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.5);
  margin-bottom: 32px;
}

.header-padding {
  padding-top: 10px;
}
.menu-left {
  float: left;
  width: 225px;
  cursor: pointer;
}
.menu-right {
  float: right;
  width: calc(100% - 225px);
  max-width: 1111px;
  text-align: center;
  padding-top: 32px;
}
.kulap-logo {
  width: 225px;
  vertical-align:middle
}
.kulap-name {
  font-size: 49px;
  font-weight: bold;
  letter-spacing: 2px;
  vertical-align:middle
}
.kulap-desc {
  font-size: 13px;
  font-weight: bold;
  margin-top: -15px;
}
.menu-columns {
  float: right;
  width: 100%;
}
.menu-column {
  float: right;
  margin-left: 2%;
}

.menu-column a {
  color: #4a4a4a;
}

.menu-item span {
  font-weight: 500;
  cursor: pointer;
}
.menu-item:hover  {
  color: #00aeff;
}
.menu-active {
  color: #00aeff;
}
.menu-active-line {
  width: 100%;
  height: 3px;
  background-color: #00aeff;
  margin: 5px auto;
}
.icon-menu {
  margin-left: 8px;
  cursor: pointer;
}
.icon-account {
  line-height: 22px
}
.login-button {
  color: #2193ff;
  padding: 8px 18px;
  border: 1px solid #2193ff;
  border-radius: 20px;
  cursor: pointer;
  margin-top: -10px;

  img {
    width: 16px;
    height: 16px;
    margin-right: 5px;
    line-height: 16px;
    vertical-align: middle;
  }

  span {
    font-weight: bold;
    color: #2193ff;
    line-height: 16px;
    vertical-align: middle;
  }
}
.user-avatar {
  cursor: pointer;
  margin-top: -15px;
  position: relative;
}
.top-item {
  padding-top: 17px !important;
}
.user-popup {
  width: 235px;
  border-radius: 3px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
  background-color: #ffffff;
  position: absolute;
  left: -100px;
  z-index: 49;

  &--is-active {
    width: 100%;
    background-color: #fff;
    text-align: center;
    padding: 10px 22px;
    border-radius: 3px 3px 0 0;
    cursor: pointer;

    span {
      display: block;
      width: 100%;
      padding: 7px;
      background-color: #f15c25;
      color: #ffffff;
      border-radius: 20px;
      font-size: 14px;
      font-weight: 900;
    }
  }

  &--is-active:hover {
    background-color: #f3f3f3;
  }

  &--item {
    float: left;
    width: 100%;
    text-align: left;
    font-size: 15px;
    font-weight: bold;
    color: #4f4f4f;
    padding: 11px 25px 0 25px;

    &--left {
      float: left;
      width: 30px;
      margin-right: 15px;
    }

    &--right {
      float: left;
      width: calc(100% - 30px - 30px);
      &--subtitle {
        font-size: 14px;
        color: #b2b2b2;
      }
    }

    &--divider {
      float: left;
      width: 100%;
      height: 1px;
      background-color: #e0e0e0;
      margin-top: 11px;
    }

    &--text {
      font-size: 14px;
      font-weight: 400;
      color: #b2b2b2;
    }
    &--kyc-status {
      color: #f15c25;
      font-size: 11px;
      float: right;
      background-color: #fff;
      text-align: center;
      padding: 3px 10px;
      border-radius: 25px;
      border: 1px solid #f15c25;
    }
  }

  &--item:hover {
    color: #2193ff;
    cursor: pointer;
    background-color: #f3f3f3;
  }

  &--item:last-child {
    padding-bottom: 11px;
  }
}

.orange-tag {
  background-color: #f15c25;
  padding: 2px 10px;
  text-align: center;
  color: #fff;
  border-radius: 20px;
}
.grey-text {
  font-size: 14px;
  color: #b2b2b2;
}
.dp-block {
  display: block;
}
.t-al-left {
  text-align: left;
}
.menu-text-style {
  color: black;
  font-weight: 500;
}
.pst-relative {
  position: relative;
}
.cursor-pointer {
  cursor: pointer;
}
.header-lang-menu {
  * {
    line-height: 17px;
    vertical-align: middle;
  }
}
.header-menu-mobile-divider {
  width: 100%;
  height: 1px;
  background-color: #c9c9c9;
  margin: 1.2rem 0 0 0;
}
.header-menu-mobile-router {
  padding-top: 1.2rem;
  padding-bottom: 0 !important;
}
.header-menu-mobile-lang {
  display: flex;
  justify-content: space-between;
}
.lang-mobile-menu-next-ic {
  transform: rotate(270deg);
  vertical-align: middle;
  margin-left: 2px;
}
.lang-mobile-menu-back-ic {
  transform: rotate(90deg);
  vertical-align: middle;
  margin-right: 2px;
}

/* Less than tablet */
@media only screen and (max-width: 1087px) {
  .user-avatar {
    margin-top: 0;
  }
  .user-popup-mobile {
    position: absolute;
    top: 100%;
    background: white;
    width: 90vw;
    max-width: 235px;
    right: -10%;
    border-radius: 3px;
    -webkit-box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
    z-index: 49;
  }
}

/* Mobile */
@media only screen and (max-width: 768px) {
  .header-container {
    height: 67px;
  }
  .kulap-logo {
    width: 137px;
    margin-top: -6px;
  }
  .kulap-name {
    font-size: 17px;
    color: #0559af;
  }
  .header-padding {
    padding-top: 15px;
  }
  .menu-left {
    width: 40%;
  }
  .menu-right {
    width: 40%;
    padding-top: 9px;
  }
  .noti-box {
    float: right;
    margin-right: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/features/Header/index.vue